export const TIME = [
  '9:00 AM - 1:00 PM',
  '1:30 PM - 5:00 PM',
  '5:30 PM - 10:00 PM'
]
